export default __webpack_public_path__ + "static/media/fingers.88459b61.ogg";